<template>
  <div class="jobContainer">
    <OpenPositionTemplate />
    <!-- <SimpleComponent /> -->
    <HomeSliderVideo />

    <div class="container">
      <SectionHeader
        titleLeft="Application"
        titleRight="Process"
        description="Our application process is designed to find talent for our dynamic IT environment. Begin with an online application to showcase your qualifications"
      />
      <div>
        <div class="card-group d-none d-xl-block">
          <div class="row">
            <div class="application-process-bg">
              <lottie-vue-player
                :src="JSON.stringify(lottie_json)"
                autoplay
                loop
                :speed="0.4"
              >
              </lottie-vue-player>
            </div>
            <div
              class="col"
              v-for="(values, index) in newProcessList"
              :key="index"
            >
              <ApplicationProcessCard
                :imageid="index + 1"
                :title_pro="values.title"
                :description_pro="values.description"
              />
            </div>
          </div>
        </div>

        <div class="d-block d-xl-none">
          <div class="row g-3">
            <div
              class="col-sm-12"
              v-for="(values, index) in newProcessList"
              :key="index"
            >
              <ApplicationProcessCard
                :imageid="index + 1"
                :title_pro="values.title"
                :description_pro="values.description"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="career">
      <CareerOptionsContainer />
    </div>
    <!-- 
    <div class="container ourCoreValuesContainer">
      <SectionHeader
        titleLeft="Our Core "
        titleRight="Values"
        description="Our core values are the guiding principles that underpin our work and define our culture. Integrity is at the heart of everything we do; we believe in honesty, transparency, and ethical behavior."
      />

      <div>
        <div class="row gx-3">
          <div
            class="col-sm-3 d-none d-xl-block"
            v-for="(values, index) in coreValues"
            :key="index"
          >
            <div :class="[(index + 1) % 2 === 0 && 'cardStyle']">
              <CoreValueCard
                :borderColor="values.borderColor"
                :title="values.title"
                :description="values.description"
              />
            </div>
          </div>
        </div>
        <div class="row g-3">
          <div
            class="col-6 col-md-6 d-block d-xl-none"
            v-for="(values, index) in coreValues"
            :key="index"
          >
            <CoreValueCard
              :borderColor="values.borderColor"
              :title="values.title"
              :description="values.description"
            />
          </div>
        </div>
      </div>
    </div> -->
    <div class="w-100 mt-5" style="background-color: #eff6fa !important">
      <div class="container ourCoreValuesContainer pb-5">
        <SectionHeader
          titleLeft="Our Core "
          titleRight="Values"
          description="Our core values are the guiding principles that underpin our work and define our culture. Integrity is at the heart of everything we do; we believe in honesty, transparency, and ethical behavior."
        />

        <div>
          <div class="row gx-3">
            <div
              class="col-sm-3 mb-3"
              v-for="(item, index) in coreValues"
              :key="index"
            >
              <div class="d-flex p-4 gap-2 align-items-center core-card">
                <div>
                  <img
                    :src="item.icon"
                    alt=""
                    class="core-card-icon object-fit-contain image-process"
                  />
                </div>
                <div></div>
                <div>
                  <h6 class="fs-4">{{ item.title }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lifeAtMWContainer">
      <div class="pb-5">
        <div class="container">
          <SectionHeader
            titleLeft="Life At"
            titleRight="Mediusware"
            description="Our employees thrives on solving complex challenges, embracing new technologies, and pushing the boundaries of what's possible in the software world."
          />
        </div>
        <!-- dynamicColor="#757E95" -->

        <!-- <div class="row">
          <div class="col-12 cs-grid">
            <div
              class="mb-3 mb-sm-4 mb-lg-5"
              v-for="(values, index) in 6"
              :key="index"
            >
              <img
                :src="
                  '../../../assets/lifeAtMediusware/compressed-lifeat' +
                  (index + 1) +
                  '.jpg'
                "
                alt=""
                class="w-100"
              />
            </div>
          </div>
        </div> -->

        <div v-if="gallaries.length" class="position-relative">
          <!-- Pass settings to VueSlickCarousel -->
          <VueSlickCarousel
            :ref="VueSlickCarouselcustom"
            :dots="slickSettings.dots"
            :infinite="slickSettings.infinite"
            :autoplay="slickSettings.autoplay"
            :autoplaySpeed="slickSettings.autoplaySpeed"
            :slidesToShow="slickSettings.slidesToShow"
            :slidesToScroll="slickSettings.slidesToScroll"
            :arrows="slickSettings.arrows"
            :responsive="slickSettings.responsive"
            :speed="slickSettings.speed"
            :cssEase="slickSettings.cssEase"
          >
            <div
              v-for="(item, index) in gallaries"
              :key="index"
              class="px-2 position-relative slide"
            >
              <div
                class="card shadow-sm rounded cursor-pointer"
                style="border: none !important"
              >
                <div
                  class="card-img-top object-fit-cover rounded-2"
                  :style="{
                    backgroundImage: `url(${item})`,
                    height: '350px',
                    width: '100%',
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                  }"
                  @click="openModal(item, index)"
                ></div>
              </div>
            </div>
          </VueSlickCarousel>

          <!-- 🪟 Image Modal -->
          <div v-if="modalOpen" class="custom-modal">
            <div class="modal-content" @click.stop>
              <div
                class="modal-header d-flex justify-content-between align-items-center pb-3"
              >
                <h5 class="modal-title">Image Preview</h5>
                <button
                  type="button"
                  class="close mb-2 rounded-circle px-2"
                  @click="closeModal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body rounded-1 text-center position-relative">
                <button
                  class="carousel-button button-custom-color position-absolute start-0 top-50 translate-middle-y"
                  @click="showPrevInner"
                >
                  <i class="fas fa-chevron-left fa-lg"></i>
                </button>

                <img
                  v-if="currentImage"
                  :src="currentImage"
                  alt="Selected"
                  class="img-fluid rounded"
                  style="max-height: 420px; object-fit: contain"
                />

                <button
                  class="carousel-button button-custom-color position-absolute end-0 top-50 translate-middle-y"
                  @click="showNextInner"
                >
                  <i class="fas fa-chevron-right fa-lg"></i>
                </button>
              </div>
            </div>
            <div class="modal-backdrop" @click="closeModal"></div>
          </div>

          <div class="d-flex justify-content-center mt-2">
            <div class="d-flex justify-content-center mt-2">
              <div class="d-flex gap-2">
                <button
                  class="carousel-button button-custom-color"
                  @click="showPrev"
                >
                  <i class="fas fa-chevron-left fa-lg"></i>
                </button>

                <button
                  class="carousel-button button-custom-color"
                  @click="showNext"
                >
                  <i class="fas fa-chevron-right fa-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import LottieAnimation from "lottie-web-vue"
import Animationlayer from "./Animationlayer2.json";
import SectionHeader from "../../../components/SectionHeader.vue";
import CoreValueCard from "../../../components/CoreValueCard.vue";
import OpenPositionTemplate from "../../../components/OpenPositionTemplate.vue";
import ApplicationProcessCard from "../../../components/ApplicationProcessCard.vue";
import CareerOptionsContainer from "../../../components/CareerOptionsContainer.vue";
import SimpleComponent from "../../../components/JobsHomeSliderOne.vue";
import HomeSliderVideo from "../../../components/HomeSlickVideoSlider.vue";
import envelopeIcon from "../../../../public/assets/fitness.svg";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  name: "NewJob",
  components: {
    OpenPositionTemplate,
    SectionHeader,
    CoreValueCard,
    ApplicationProcessCard,
    CareerOptionsContainer,
    SimpleComponent,
    HomeSliderVideo,
    VueSlickCarousel,
  },

  data() {
    return {
      lottie_json: Animationlayer,
      newProcessList: [
        {
          title: "Application review",
          description:
            "We evaluate applications using multiple criteria to find the best candidates.",
        },
        {
          title: "Quick test",
          description:
            "We conduct online interviews to get to know you better.",
        },
        {
          title: "Exam",
          description:
            "Finalists participate in a one-day onsite challenge for the final judge.",
        },
        {
          title: "Interviews",
          description:
            "Team leads are conducting this interview to recruit new hires.",
        },
        {
          title: "Offer",
          description:
            "After a successful interview, you'll get a job offer at Mediusware.",
        },
      ],
      slickSettings: {
        dots: false,
        infinite: true,
        speed: 3000,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 556,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      modalOpen: false,
      currentImage: null,
      currentIndex: 0,

      slideList: [
        {
          img: "https://picsum.photos/800/300/?image=1",
        },

        {
          img: "https://picsum.photos/800/300/?image=1",
        },
      ],
    };
  },
  methods: {
    openModal(image, index) {
      this.currentImage = image;
      this.currentIndex = index;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
      this.currentImage = null;
    },

    showNext() {
      this.$refs.VueSlickCarouselcustom.next();
    },
    showPrev() {
      this.$refs.VueSlickCarouselcustom.prev();
    },

    showNextInner() {
      if (!this.gallaries.length) return;
      this.currentIndex = (this.currentIndex + 1) % this.gallaries.length;
      this.currentImage = this.gallaries[this.currentIndex];
    },

    showPrevInner() {
      if (!this.gallaries.length) return;
      this.currentIndex =
        (this.currentIndex - 1 + this.gallaries.length) % this.gallaries.length;
      this.currentImage = this.gallaries[this.currentIndex];
    },
  },
  computed: {
    coreValues() {
      return this.$store.state.coreValues;
    },
    gallaries() {
      return this.$store.state.gallaries;
    },
  },
  created() {
    this.$store.dispatch("fetchCoreValues");
  },
  created() {
    this.$store.dispatch("fetchOurGallary");
  },
};
</script>

<style scoped lang="scss">
.jobContainer {
  .appProcessContainer {
    .card-group {
      position: relative;

      .application-process-bg {
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
      }
    }
  }

  .ourCoreValuesContainer {
    .cardStyle {
      margin-top: 24px;
    }
  }

  .cs-grid {
    display: grid;
    grid-template-columns: 1fr 493px 1fr;
  }

  @media (max-width: 1399px) {
    .cs-grid {
      display: grid;
      grid-template-columns: 1fr 424px 1fr;
    }
  }

  @media (max-width: 1199px) {
    .cs-grid {
      display: grid;
      grid-template-columns: 1fr 356px 1fr;
    }
  }

  @media (max-width: 991px) {
    .cs-grid {
      display: grid;
      grid-template-columns: 1fr 265px 1fr;
    }
  }

  @media (max-width: 768px) {
    .cs-grid {
      display: grid;
      grid-template-columns: 1fr 197px 1fr;
    }
  }

  @media (max-width: 575px) {
    .cs-grid {
      display: grid;
      grid-template-columns: 1fr 163px 1fr;
    }
    .core-card {
      min-height: 100px;
    }
  }

  @media (max-width: 399px) {
    .cs-grid {
      display: grid;
      grid-template-columns: 1fr 136px 1fr;
    }
  }
}
.item-icon {
  width: 100px;
  height: 100px;
}
.images-process {
  height: 60px;
  width: 60px;
  margin-right: 1rem;
}
.core-card {
  background: #fdfdfd !important;

  border-radius: 12px;
  cursor: pointer;
  min-height: 130px;
}
.core-card-icon {
  width: 30px;
  height: 30px;
}
.carousel-button {
  width: 35px;
  cursor: pointer;
  padding: 5px;
}
.carousel-button svg {
  fill: #002b4f;
}

.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
  position: relative;
  max-height: 750px;
  z-index: 999999;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}

.carousel-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #091e42;
  color: #091e42;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.carousel-button:hover {
  background-color: #091e42;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.carousel-button i {
  transition: transform 0.3s ease;
}

.carousel-button svg {
  fill: #002b4f;
}

.card {
  border: none !important;
  height: 350px;
}
</style>
